import OpportunityHeader from "./components/OpportunityHeader";

export default OpportunityHeader;